import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import { defaultPagingChoices } from "@/js/lists.ts";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
export default {
  name: "adminEventList",
  data: function data() {
    return {
      headers: [{
        text: "Title",
        value: "titleForAdmin"
      }, {
        text: "Event URL",
        value: "eventUrl"
      }, {
        text: "Visible / Accessible to users",
        value: "isPublicVisible"
      }, {
        text: "Actions",
        value: "actions",
        sortable: false
      }],
      gettingEvents: {
        items: [],
        numberOfPages: 0,
        numberOfEvents: 0,
        loading: false,
        error: null,
        cancellationToken: null
      },
      pagingLimitsChoices: defaultPagingChoices,
      formSearch: {
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        }
      }
    };
  },
  components: {
    paging: pagingComponent,
    index: indexComponent
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var filters;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getFilters();
          case 2:
            filters = _context.sent;
            if (filters !== null && filters !== void 0 && filters.events) {
              _this2.formSearch = _objectSpread(_objectSpread({}, _this2.formSearch), filters.events);
            }
            _this2.search();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    hasResult: function hasResult() {
      return !this.gettingEvents.loading && this.gettingEvents.numberOfEvents > 0;
    }
  },
  methods: {
    goToAdd: function goToAdd() {
      return {
        name: "adminEventDetails",
        params: {
          id: 0
        }
      };
    },
    goToEventPage: function goToEventPage(event) {
      return {
        name: "adminEventDetails",
        params: {
          id: event.id
        }
      };
    },
    changePage: function changePage(page) {
      this.formSearch.paging.askedPage = page;
      this.search();
    },
    search: function search() {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$gettingEvents$;
        var resetPage, paramsQuery, _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              resetPage = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              if (resetPage) {
                _this3.formSearch.paging.askedPage = 0;
              }
              setFilters(function (state) {
                return _objectSpread(_objectSpread({}, state), {}, {
                  events: _this3.formSearch
                });
              });
              _this3.gettingEvents.loading = true;
              _this3.gettingEvents.error = null;
              (_this3$gettingEvents$ = _this3.gettingEvents.cancellationToken) === null || _this3$gettingEvents$ === void 0 || _this3$gettingEvents$.cancel();
              _this3.gettingEvents.cancellationToken = axios.CancelToken.source();
              paramsQuery = Object.encodeToUri(_this3.formSearch);
              _this = _this3;
              _context2.next = 11;
              return request("/v1/events?params=".concat(paramsQuery), "get", null, true, "api", null, _this.gettingEvents.cancellationToken).catch(function (error) {
                _this.gettingEvents.error = error;
                _this.gettingEvents.loading = false;
              });
            case 11:
              response = _context2.sent;
              response = response.data.value;
              _this3.gettingEvents.items = response.events;
              _this3.gettingEvents.numberOfPages = Math.ceil(response.totalNumbersOfEvents / _this3.formSearch.paging.limits);
              _this3.gettingEvents.numberOfEvents = response.totalNumbersOfEvents;
              _this3.formSearch.paging.currentPage = response.currentPage;
              _this3.formSearch.paging.currentPage = _this3.formSearch.paging.askedPage + 1;
              if (!_this3.formSearch.paging.currentPage) {
                _this3.formSearch.paging.currentPage = 0;
              }
              _this3.gettingEvents.loading = false;
              _this3.gettingEvents.cancellationToken = null;
            case 21:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    openUrl: function openUrl(url) {
      window.open(url, "_blank");
    },
    getUniqueEventUrl: function getUniqueEventUrl(event) {
      return window.location.origin + "/events/" + event.eventUrl;
    }
  }
};